import React from 'react'
import { UseFormReturn } from 'react-hook-form';
import { VirtualMedicine } from '../../../../apis/virtual-medicines/types';
import CreateVirtualMedicine from './CreateVirtualMedicine';
import SaveVirtualMedicine from './SaveVirtualMedicine';

interface Props {
  form: UseFormReturn<VirtualMedicine>;
  id?: string;
}

const CreateSaveVirtualMedicineButton = ({ form, id }: Props) => {
  if (!id) {
  return <CreateVirtualMedicine form={form} />;
  }

  return <SaveVirtualMedicine id={id} form={form} />;
};
export default CreateSaveVirtualMedicineButton;
